import { ENUM__component_type } from '@/enums/ENUM__component_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_hint_shortcut } from '@/hooks/hints_shortcut/use_hint_shortcut';
import { HOOK__notifier } from '@/hooks/HOOK__notifier';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { remote_collection_create } from '@/state/collection/entity/remote_collection_create';
import { set_collection_current } from '@/utils/utils_client_workspace_child_entity_viewers';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { useState } from 'react';

export function HOOK_COLLECTION__create() {
  const dispatch = use_dispatch();

  const { workspace_current } = use_slice_workspace(['workspace_current']);

  const [is_loading, set_is_loading] = useState(false);
  const [component_id, set_component_id] = useState('');

  const notifier = HOOK__notifier(component_id, ENUM__workspace_entity.COLLECTION_CUSTOM);

  const { on_user_uses_component, on_user_uses_shortcut } = use_hint_shortcut(EShortcutType.COLLECTIONS_CREATE);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (component_id) void notifier.send_action();
  }, [component_id]);

  /*
   * METHODS
   */

  async function create_collection(is_used_shortcut: boolean) {
    is_used_shortcut ? on_user_uses_shortcut() : on_user_uses_component();

    set_is_loading(true);
    let action_result = await dispatch(remote_collection_create(workspace_current._id));
    set_is_loading(false);

    if (typeof action_result.payload != 'string') return;

    let collection_id = action_result.payload;
    set_collection_current(collection_id);

    set_component_id(`${ENUM__component_type.PAGE_COLLECTION_ITEM_LIST}_${collection_id}`);
  }

  return { is_loading, create_collection };
}
